// This file was auto-generated by querybuilder/Apollo and should not be edited.

import * as ExtendedFormFieldErrors from './ExtendedFormFieldErrors';
import * as LandlordDetailsType from './LandlordDetailsType';
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { LandlordDetailsV2Input } from "./globalTypes";

// ====================================================
// GraphQL mutation operation: LandlordDetailsV2Mutation
// ====================================================

export interface LandlordDetailsV2Mutation_output_errors_extendedMessages {
  /**
   * A human-readable validation error.
   */
  message: string;
  /**
   * A machine-readable representation of the error.
   */
  code: string | null;
}

export interface LandlordDetailsV2Mutation_output_errors {
  /**
   * The camel-cased name of the input field, or '__all__' for non-field errors.
   */
  field: string;
  /**
   * A list of validation errors with extended metadata.
   */
  extendedMessages: LandlordDetailsV2Mutation_output_errors_extendedMessages[];
}

export interface LandlordDetailsV2Mutation_output_session_landlordDetails {
  /**
   * Usually the first line of the address, e.g. "150 Court Street"
   */
  primaryLine: string;
  /**
   * The city of the address, e.g. "Brooklyn".
   */
  city: string;
  /**
   * The zip code of the address, e.g. "11201" or "94107-2282".
   */
  zipCode: string;
  /**
   * The landlord's name.
   */
  name: string;
  /**
   * The landlord's email address.
   */
  email: string;
  /**
   * A U.S. phone number without parentheses or hyphens, e.g. "5551234567".
   */
  phoneNumber: string;
  /**
   * Whether the name and address was looked up automatically, or manually entered by the user.
   */
  isLookedUp: boolean;
  /**
   * The full mailing address of the user, as a single string. Note that this may
   * actually be populated even if individual address fields are empty; this
   * represents legacy data created before we split up addresses into individual fields.
   */
  address: string;
  state: string;
}

export interface LandlordDetailsV2Mutation_output_session {
  landlordDetails: LandlordDetailsV2Mutation_output_session_landlordDetails | null;
}

export interface LandlordDetailsV2Mutation_output {
  /**
   * A list of validation errors in the form, if any. If the form was valid, this list will be empty.
   */
  errors: LandlordDetailsV2Mutation_output_errors[];
  session: LandlordDetailsV2Mutation_output_session | null;
  /**
   * Whether or not the provided address appears to be undeliverable. If Lob
   * integration is disabled, there was a problem contacting Lob, or the mutation
   * was unsuccessful, this will be null.
   */
  isUndeliverable: boolean | null;
}

export interface LandlordDetailsV2Mutation {
  output: LandlordDetailsV2Mutation_output;
}

export interface LandlordDetailsV2MutationVariables {
  input: LandlordDetailsV2Input;
}

export const BlankLandlordDetailsV2Input: LandlordDetailsV2Input = {
  "name": "",
  "primaryLine": "",
  "city": "",
  "state": "",
  "zipCode": ""
};

export const LandlordDetailsV2Mutation = {
  // The following query was taken from LandlordDetailsV2Mutation.graphql.
  graphQL: `# This file was auto-generated by querybuilder, please do not edit it.
mutation LandlordDetailsV2Mutation($input: LandlordDetailsV2Input!) {
  output: landlordDetailsV2(input: $input) {
    errors { ...ExtendedFormFieldErrors },
    session {
      landlordDetails { ...LandlordDetailsType }
    },
    isUndeliverable
  }
}
${ExtendedFormFieldErrors.graphQL}
${LandlordDetailsType.graphQL}`,
  name: "LandlordDetailsV2Mutation",
  fetch(fetchGraphQL: (query: string, args?: any) => Promise<any>, args: LandlordDetailsV2MutationVariables): Promise<LandlordDetailsV2Mutation> {
    return fetchGraphQL(LandlordDetailsV2Mutation.graphQL, args);
  },
  blankInput: BlankLandlordDetailsV2Input,
};

export const fetchLandlordDetailsV2Mutation = LandlordDetailsV2Mutation.fetch;